export default __webpack_public_path__ + "static/media/hero-the-company.2ba7c098.jpg";